import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';

export interface IComunidadAutonomaProvinciasSexoProps {
    comunidadAutonoma: string;
}

export interface IComunidadAutonomaProvinciasSexoState {
    dataMen: number[];
    dataWomen: number[];
    data: any[];
}

export default class ComunidadAutonomaProvinciasSexo extends React.Component<IComunidadAutonomaProvinciasSexoProps, IComunidadAutonomaProvinciasSexoState> {
    public constructor(props: IComunidadAutonomaProvinciasSexoProps) {
        super(props);

        this.state = {
            dataMen: [],
            dataWomen: [],
            data: []
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IComunidadAutonomaProvinciasSexoProps>, nextContext: any): void {
        this.GetMen(nextProps.comunidadAutonoma);
    }

    componentDidMount(): void {
        this.GetMen(this.props.comunidadAutonoma);
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            Distribución de sexo por provincias
                        </Typography>
                    </Box>
                    <BarChart
                        dataset={this.state.data}
                        xAxis={[{ scaleType: 'band', dataKey: 'provincia' }]}
                        series={[
                            { dataKey: 'hombres', label: 'Hombres', stack: 'Total', color: Common.MAN_COLOR },
                            { dataKey: 'mujeres', label: 'Mujeres', stack: 'Total', color: Common.WOMAN_COLOR}
                        ]}
                        height={350}
                        margin={{
                            bottom: 100
                        }}
                        slotProps={
                            {
                                legend: {
                                    direction: 'row',
                                    position: {
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    },
                                    itemMarkWidth: 20,
                                    itemMarkHeight: 6,
                                    markGap: 5,
                                    itemGap: 10,
                                    labelStyle: {
                                        fontSize: 11
                                    }
                                }
                            }
                        }
                    />
                </CardContent>
            </Card>
        )
    }

    private GetMen(comunidadAutonoma: string) {
        let url = `${Common.END_POINT}/charts/provincia/total/comunidadautonoma/${comunidadAutonoma}/sexo/h`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.provincia = response[i].provincia;
                dataItem.hombres = response[i].total;
                dataItem.mujeres = 0;

                data.push(dataItem);
            }

            this.GetWomen(comunidadAutonoma, data);
        })
    }

    private GetWomen(comunidadAutonoma: string, sourceData: any[]) {
        let url = `${Common.END_POINT}/charts/provincia/total/comunidadautonoma/${comunidadAutonoma}/sexo/m`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = JSON.parse(JSON.stringify(sourceData));

            for(let i = 0; i < response.length; i++) {
                let dataItem: any = data.find((value: any) => {
                    return value.provincia == response[i].provincia;
                });

                if (dataItem == null) {
                    dataItem = {};
                    dataItem.provincia = response[i].provincia;
                    dataItem.hombres = 0;

                    data.push(dataItem);
                }

                dataItem.mujeres = response[i].total;
            }

            data.sort((a, b) => {
                if(a.provincia < b.provincia) { return -1; }
                if(a.provincia > b.provincia) { return 1; }
                return 0;
            });

            this.setState({
                data: data
            })
        })
    }
}